import * as React from 'react';
import * as styled from './styled';
import {TestAnswerBlock} from 'api/task/types';
import {useContext} from '../../../../hooks/useContext';
import {Answer} from './components/Answer';

/**
 * The test content render.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Test(): React.ReactElement {
  const {block} = useContext();

  // @ts-ignore
  const answers: TestAnswerBlock[] = block.answers || [];

  return (
    <styled.Wrapper>
      {answers.map((answer, index) => (
        <Answer
          key={index}
          index={index}
          {...answer}
        />
      ))}
    </styled.Wrapper>
  );
}
